



















import { Component, Vue, Prop } from 'vue-property-decorator';
import { Conversation } from '../models/conversation';
import ContactConversation from './ContactConversation.vue';
import LoadingSpinner from '@/shared/components/loadingSpinner/LoadingSpinner.vue';

@Component({ components: { LoadingSpinner, ContactConversation } })
export default class ContactConversationList extends Vue {
	@Prop({ default: () => [] }) public conversations: Conversation[];

	@Prop() public workspaceId: string;

	@Prop({ default: false }) public loading!: boolean;
}
